import { UserAuth } from '@/modules/authentication/model/user';
import { AuthenticationService } from '@/modules/authentication/services/authentication.service';
import { ApplicationConfigService } from '@/modules/services/application-config/application-config.service';
import { AppInfoFactory } from '@/shared/factory/app-info/app-info.factory';
import { UsersFactory } from '@/shared/factory/users/users.factory';
import { UserModel } from '@/shared/model/user-model';
import { NotificationUtil } from '@/shared/util/notification.util';
import { StringUtils } from '@/shared/util/string.utils';
import { ActiveWorkspaceState, AuthState, Company } from '@/store/auth/types';
import { UIState } from '@/store/ui/types';
import amplitude from 'amplitude-js';
import { debounce } from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';

const uiModule = namespace('ui');
const authModule = namespace('auth');

interface UI {
    user?: UserModel;
    userAuth?: UserAuth;

    menuOpened: string;
    menuFilter: string;
    status: {
        sidebarExpand: boolean;
    };
    visible: {
        workspace: boolean;
        userMenu: boolean;
    };
}

@Component({
    template: require('./bs-taskbar.html'),
})
export class BSTaskbarComponent extends Vue {

    ui: UI = {
        user: {
            firstName: ''
        },
        userAuth: undefined,

        menuOpened: '',
        menuFilter: '',
        status: {
            sidebarExpand: false,
        },
        visible: {
            workspace: false,
            userMenu: false,
        }
    };
    search = '';
    filteredWorkspace: Array<Company> = [];

    @State('ui') i: UIState;

    @State('auth') auth: AuthState;
    @authModule.Getter('username') username: string;
    @authModule.Getter('workspaces') workspaces: Array<Company>;
    @authModule.Getter('activeWorkspace') activeWorkspace: ActiveWorkspaceState;

    private amplitudeProject = amplitude.getInstance();

    created() {
        if (AuthenticationService.isAuthenticated) {
            this.ui.userAuth = AuthenticationService.user;
        }

        const userId: string = this.ui.userAuth!.id!;
        new UsersFactory().getUserById(userId).then((user: UserModel) => {
            this.ui.user = user;
        });
        this.loadAppInfo();
    }

    mounted() {
        this.filteredWorkspace = Object.assign([], this.workspaces);
    }

    onSearch() {
        debounce(() => {
            if (!this.search.trim()) {
                this.filteredWorkspace = Object.assign([], this.workspaces);
                return;
            }
            this.filteredWorkspace = this.workspaces.filter(work => StringUtils.replaceUtils(work.name.toLowerCase()).includes(StringUtils.replaceUtils(this.search.trim().toLowerCase())));
        }, 500)();
    }

    @Watch('workspaces')
    onSwitchWorkspace() {
        this.search = '';
        this.filteredWorkspace = Object.assign([], this.workspaces);
        this.logAmplitudeWorkspace();
    }

    async logout() {
        AuthenticationService.logout(ApplicationConfigService.urlSuite);
    }


    private async loadAppInfo() {
        // Carrega o perfil do usuário caso não esteja previamente carregado
        if (AuthenticationService.isAuthenticated) {
            try {
                const appInfo = await AppInfoFactory.getAppInfo();
                ApplicationConfigService.setUrlGpassAdmin(appInfo.gpassAdminUrl);
                ApplicationConfigService.setUrlSuite(appInfo.suiteUrl);
                ApplicationConfigService.sethasFitBankAccount(appInfo.hasFitBankAccount);
            } catch (e) {
                NotificationUtil.error(e);
                // AuthenticationService.logout();
            }
        }
    }

    get userInfo() {
        return this.ui.user;
    }

    get visible(): boolean {
        return this.i.taskbarVisible;
    }

    get companyWorkspace(): string {
        return this.activeWorkspace ? this.activeWorkspace.name : '';
    }

    toggleUser() {
        this.ui.visible.userMenu = !this.ui.visible.userMenu;
    }

    hideWorkspaceMenu() {
        this.ui.visible.workspace = false;
    }

    hideUserMenu() {
        this.ui.visible.userMenu = false;
    }

    get isWorkspaceActive() {
        return this.ui.visible.workspace;
    }

    get isUserMenuActive() {
        return this.ui.visible.userMenu;
    }

    get urlSuite() {
        return ApplicationConfigService.urlSuite;
    }

    redirectToPassword() {
        location.href = `${this.urlSuite}/alterar-senha`;
    }

    get isSidebarExpand() {
        return this.ui.status.sidebarExpand;
    }

    get setSidebarClass() {
        return this.ui.status.sidebarExpand ? 'sidebar-expanded' : 'sidebar-compressed';
    }

    onClickOutside() {
        this.ui.status.sidebarExpand = false;
        this.ui.menuFilter = '';
    }

    toggleExpand() {
        this.ui.menuOpened = '';
        this.ui.status.sidebarExpand = !this.ui.status.sidebarExpand;

        this.$emit('on-toggle-expand', this.ui.status.sidebarExpand);
    }

    redirectToSuite() {
        window.location.href = ApplicationConfigService.urlSuite;
    }

    /********************************************************************
        AMPLITUDE - EVENTOS DO GRUPO TASKBAR
    *********************************************************************/

    logAmplitudeWorkspace() {
        this.amplitudeProject.logEvent('switch_workspace', { source: 'taskbar' });
    }
}
